import { Component, Input } from '@angular/core';
import { AggregatedJobData, AssociationLabel, Job } from '@shared';
import { AvatarBackgroundSizes, AvatarShapes } from 'mojo-avatar';
import { Elevations } from 'mojo-card';

@Component({
  selector: 'mojo-reports-job-item-common',
  styleUrls: ['./reports-job-item-common.component.scss'],
  templateUrl: './reports-job-item-common.component.html',
})
export class ReportsJobItemCommonComponent {
  @Input() jobItem: Job;
  @Input() aggregatedJobData: AggregatedJobData;

  associationLabel = JSON.stringify(AssociationLabel.DIRECT);
  avatarPhotoShape = AvatarShapes.circle;
  avatarBackgroundSizes = AvatarBackgroundSizes.cover;
  elevation = Elevations.first;
}
